import './MainPage.css'
import Top from './Top'
import DownLoad from "./DownLoad";
import Antivirus from "./Antivirus";
import Introduction from './Introduction'
import Advantage from './Advantage'
import Payment from "./Payment"
import MyCompany from "./Footer";
import AboutUs from './AboutUs'
import ContactUs from './ContactUs'

function mainPage() {
    const path = window.location.pathname
    if (path.indexOf('aboutUs') >= 0) {
        return <AboutUs/>
    }
    if (path.indexOf('contactUs') >= 0) {
        return <ContactUs/>
    }
    return (
        <div className="mainPage">
            <Top/>
            <DownLoad/>
            <Antivirus/>
            <Introduction/>
            <Advantage/>
            <Payment/>
            <MyCompany/>
        </div>
    );
}

export default mainPage